<template>
    <div>
        <div class="card">
            <div class="card-header main-card">
                Administración de resorts
            </div>
            <div class="card-body">
                <b-container>
                    <div class="mb-4">
                        <span class="mr-4">
                            Selecciona la zona
                        </span>
                        <b-form-select @change="getData" v-model="suprazone_id" class="">
                            <option value="0">Seleccione zona...</option>
                            <option v-for="suprazone in suprazones" :key="suprazone.id" :value="suprazone.id">{{suprazone.name}}</option>
                        </b-form-select>
                    </div>
                    <div v-for="(group, idx) in subzonesListAdmin" :key="idx">
                        <b-container>
                            <p class="font-weight-bold">
                                {{group.name}}
                            </p>
                            <admin-subzones-table :rows="group.subzones" :pickupzone="group" />
                        </b-container>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import AdminAddSubzoneModal from './AdminAddSubzoneModal'
import AdminSubzonesTable from './AdminSubzonesTable'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminAddSubzoneModal,
        AdminSubzonesTable,
    },
    data() {
        return {
            suprazone: {},
            suprazone_id: 0,
        }
    },
    beforeDestroy() {
        // clean list
        this.$store.commit('subzones/RESET_SUBZONES_LIST_ADMIN')
    },
    async mounted() {
        this.$store.commit('subzones/RESET_SUBZONES_LIST_ADMIN')
        await this.$store.dispatch("suprazones/loadSuprazones")
    },
    methods: {
        async getData() {
            //await this.$store.dispatch('subzones/getSubzonesBySuprazone', {suprazone_id: this.suprazone_id})
            await this.$store.dispatch('subzones/getSubzonesGroupByPickupzone', {suprazone_id: this.suprazone_id})
            this.suprazone = this.suprazoneAdminCurrent(this.suprazone_id)

        }
    },
    computed: {
        ...mapGetters(['suprazones', 'suprazoneAdminCurrent', 'subzonesListAdmin']),
        grouping() {
            let g = _.mapValues(
                _.groupBy(
                    this.subzonesListAdmin, 'pickup_zone.name'
                ),
            )
            return g
        }
    },
    
}
</script>